// src/components/FloatingButtons.js (FINAL)

import React from 'react';
import './FloatingButtons.css';
import { FiYoutube } from 'react-icons/fi';
import { FaWhatsapp } from 'react-icons/fa'; 

const FloatingButtons = () => {
    // 🛑 NÚMERO DE WHATSAPP DEL DR. GIOVANNI SCARVACI
    const whatsappNumber = '14078738172'; 
    const whatsappLink = `https://wa.me/${whatsappNumber.replace(/\s/g, '')}`;

    // 🛑 URL DE YOUTUBE PROPORCIONADA
    const youtubeLink = 'https://www.youtube.com/@GiovanniScarvaciYAsociados';

    return (
        <div className="floating-container">
            {/* WhatsApp - Para Leads */}
            <a 
                href={whatsappLink}
                target="_blank" 
                rel="noopener noreferrer"
                className="floating-btn whatsapp"
                title="Escríbenos por WhatsApp"
            >
                <FaWhatsapp /> 
            </a>
            
            {/* YouTube - Para Contenido */}
            <a 
                href={youtubeLink} // 🛑 URL APLICADA AQUÍ
                target="_blank" 
                rel="noopener noreferrer"
                className="floating-btn youtube"
                title="Ver nuestro canal de YouTube"
            >
                <FiYoutube /> 
            </a>
        </div>
    );
};

export default FloatingButtons;